import {GeneralAction} from '../../../@types/actions';
import {DELETE_MONITOR_SETTINGS} from "../../../constants/MonitorConstants";

export const DeleteSettingsAction = (template: string): GeneralAction<string> => ({
    type: DELETE_MONITOR_SETTINGS,
    payload: template
});
